import { DOCS_FORM_NAMES } from "core/consts";
import { FormFieldConfigFactory } from "..";
import { DischargeLetterFormSchema } from "./schema";
import { DischargeLetterFormSections } from "./sections";

export const getDischargeLetterFormConfig: FormFieldConfigFactory<
  typeof DOCS_FORM_NAMES.DISCHARGE_LETTER
> = () => {
  return {
    auctionToForm: () => {
      return {
        test1: () => {
          return undefined;
        },
        test2: () => {
          return undefined;
        },
        test3: () => {
          return undefined;
        },
        test4: () => {
          return undefined;
        },
        test5: () => {
          return undefined;
        },
      };
    },
    getInitialValue: ({ value }) => {
      return {
        test1: value?.test1 ?? undefined,
        test2: value?.test2 ?? undefined,
        test3: value?.test3 ?? undefined,
        test4: value?.test4 ?? undefined,
        test5: value?.test5 ?? undefined,
      };
    },
    header: () => "test",
    schema: DischargeLetterFormSchema,
    sections: DischargeLetterFormSections,
    title: () => "test",
  };
};
